<template>
    <div class="avatar">
        <div v-if="!!imageUrl">
            <div class="avatar-image" :style="`background-image: URL(${imageSrc})`"></div>
        </div>
        <div v-else>
            <i class="fa text-primary" style="font-size: 15rem;" :class="icon"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        imageUrl: {
            type: String,

        },
        type: {
            type: String,
            default: 'person',
            validator: (val) => ['person', 'vehicle'].includes(val)
        }
    },
    computed: {
        icon() {
            return this.type === 'person'
                ? 'fa-user'
                : 'fa-car'
        },
        imageSrc() {
            return !!this.imageUrl? this.imageUrl: this.icon
        }
    }
}
</script>

<style scoped>
    .avatar {
        /*  */
    }
    .avatar-image {
        width: 250px;
        height: 250px;
        border-radius: 100%;
        background-size: cover;
    }
</style>
